import i18n from 'i18n';
import { FormTemplateValidator } from 'data/template/template.types';

export default class LengthValidator {
  private static TYPE = 'length';

  public static isType(type: string): boolean {
    return LengthValidator.TYPE === type;
  }

  public static isValid(
    _propFields: unknown,
    _stateFields: unknown,
    value: string,
    _lastSavedValue: unknown,
    validator: FormTemplateValidator,
    _form: unknown,
  ): boolean {
    return validator.length == null || value.toString().length <= validator.length;
  }

  public static getErrorMessage({ length }: FormTemplateValidator): string | null {
    return i18n.t('common.form.fieldError.length', { length });
  }
}
